import React from "react"
import classNames from "classnames"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"

const InventoryExploreChartOrganism = () => {
  const { pillarId: urlPillarId } = useParams()

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId, "page-frame")}>
        <div className={classNames("page")}>
          <div
            id="widget1"
            className={classNames(urlPillarId, "widget", "chart")}
          >
            <MetabaseChartMolecule
              verdikt_alias={"dashboard_explore_inventory"}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InventoryExploreChartOrganism
